import React, { createContext, useContext } from 'react';
import { en, TranslationKeys } from './translations/en';
import { tr } from './translations/tr';

export type Language = 'EN' | 'TR';

const translations: Record<Language, TranslationKeys> = { EN: en, TR: tr };

const I18nContext = createContext<TranslationKeys>(en);

/** Detect browser language, returning 'TR' if Turkish, otherwise 'EN'. */
export function detectBrowserLanguage(): Language {
  const lang = (navigator.language || '').toLowerCase();
  if (lang.startsWith('tr')) return 'TR';
  return 'EN';
}

interface I18nProviderProps {
  language: Language;
  children: React.ReactNode;
}

export const I18nProvider: React.FC<I18nProviderProps> = ({ language, children }) => {
  const t = translations[language] || en;
  return <I18nContext.Provider value={t}>{children}</I18nContext.Provider>;
};

/** Hook to access translations */
export const useTranslation = () => useContext(I18nContext);
